module.exports = __webpack_public_path__ + "img/h-box-1.6c0a67d1.png";